export { default as TabsBar } from './tabs-bar';
export { default as TabPanels } from './tab-panels';
